import { Component } from '@angular/core';
import { BaseState } from '@base/entities/BaseEntities';
import { BaseComponent } from '@base/component/BaseComponent';
import { ServiceBagService } from '@base/component/ServiceBag';
import { SysGlobals } from '@core/framework/sysglobals';

@Component({
    selector: 'm4u-progresspanel',
    templateUrl: 'progresspanel.component.html',
    styleUrls: ['./progresspanel.component.scss']
})

export class ProgressPanelComponent extends BaseComponent<BaseState> {
    constructor(A: ServiceBagService) {
        super(A, 'ProgressPanelComponent', BaseState);
    }

    IsVisible(): boolean {
        return SysGlobals.IsProgressTracking;
    }

    GetText = (ratio: number, value: number): string => {
        return Math.round(ratio * 100) + '%' + ' ' + this.RC('progressIndicator');
    }

    GetValue(): number {
        return SysGlobals.ProgressPercent;
    }

}

